import { useState, useEffect, useRef } from 'react';

/**
 * Becomes true only after `active` has stayed true for `delayMs` (default 1000).
 * Resets to false as soon as `active` is false. Use to avoid flashing loading UI on fast requests.
 */
export function useDelayedTrueWhile(active, delayMs = 1000) {
  const [delayed, setDelayed] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    if (!active) {
      if (timerRef.current != null) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      setDelayed(false);
      return;
    }

    timerRef.current = setTimeout(() => {
      timerRef.current = null;
      setDelayed(true);
    }, delayMs);

    return () => {
      if (timerRef.current != null) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [active, delayMs]);

  return delayed;
}
